import { css } from "styled-components";
import { CardDescription, CardTitle, CardSubTitle } from "../../../../components/Card";
import { Grid } from "../../components/ArticlePromoCardGrid";
export const riotProductSkin = (chroma, paletteTokens) => css `
  padding: ${chroma.spacers.bladeEdge.top} 0 ${chroma.spacers.bladeEdge.bottom};

  ${Grid} {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    gap: ${chroma.spacers.variable.m};

    > * {
      flex: 1 1 var(--article-promo-card-grid-flex-basis);
      max-width: var(--article-promo-card-grid-max-width);

      ${chroma.mediaQueries.tabletDown} {
        justify-content: space-evenly;
        flex: 1 0 40%;
        max-width: 50%;
      }

      ${chroma.mediaQueries.mobileDown} {
        flex: 1 0 100%;
        max-width: 100%;
      }
    }
  }

  ${CardTitle} {
    ${chroma.typography.body2}
    margin: ${chroma.spacers.constant.s} 0 ${chroma.spacers.constant.xs};
    font-weight: bold;
  }
  ${CardSubTitle} {
    ${chroma.typography.body5}
    margin-bottom: ${chroma.spacers.constant.xxs};
    font-weight: 500;
  }

  ${CardTitle}, ${CardDescription}, ${CardSubTitle} {
    color: ${paletteTokens.bladetext1};
  }
`;
//# sourceMappingURL=index.js.map